import { render, staticRenderFns } from "./213.vue?vue&type=template&id=9956f2a0&scoped=true&"
var script = {}
import style0 from "./213.vue?vue&type=style&index=0&id=9956f2a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9956f2a0",
  null
  
)

export default component.exports